import { cardTitle } from '../../material-dashboard-pro-react.jsx';

const newProspectPageStyle = (theme) => ({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
  },
  card: {
    marginTop: 0,
  },
  phoneIcon: {
    marginTop: '0 !important',
  },
  summonVobFormButtonDiv: {
    float: 'right',
  },
  referrerFirmModal: {
    [theme.breakpoints.down('lg')]: {
      top: '100px',
    },
  },
  describeFirmCard: {
    padding: '0 12px 10px 12px',
    minWidth: '440px',
  },
  contactNameInput: {
    minWidth: '360px',
  },
  stateSelectItem: {
    marginTop: '8px',
  },
  salesStageItem: {
    marginTop: '-2px',
  },
  commTypeGridItem: {
    marginTop: '-16px',
  },
  specifyTextField: {
    marginTop: '-8px',
  },
  emergencyContactButtonDiv: {
    textAlign: 'center',
  },
  submitButtonDiv: {
    marginTop: '12px',
  },
});

export default newProspectPageStyle;
